<!--
 * @Descripttion: 
 * @Author: py
 * @Date: 2021-03-29 15:51:57
 * @LastEditors: py
 * @LastEditTime: 2021-06-02 11:08:58
-->
<template>
  <div>
    <el-dialog
      width="850px"
      top="100px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @close="resetModal"
    >
      <div slot="title" class="dialog-title">
        <span>上传资源 </span>
        <!-- <div>
          <el-popover
            placement="bottom-end"
            trigger="hover"
            :append-to-body="false"
            popper-class="popper-panel-des"
          >
            <div class="popper-content">
              <p>上传资源支持格式</p>
              <div class="formats">
                <p>文档类：doc、docx、xls、xlsx、pdf、ppt、pptx、txt</p>
                <p>图片类：jpg、bmp、png、gif、jpeg</p>
                <p>音频类：mp3、wma、wav、m4a</p>
                <p>视频类：flv、avi、mp4、wmv、asf</p>
                <p>动画类：swf</p>
                <p>压缩包：rar、zip</p>
                <p>其它: mmap、xmind、ggb</p>
              </div>
              <p>所有资源上传单次单个最多支持500M</p>
            </div>
            <img
              slot="reference"
              src="../../assets/img/icon_tip.png"
              alt=""
              class="label-tips"
            />
            <a slot="reference" class="description">上传说明</a>
          </el-popover>
        </div> -->
      </div>
      <div class="dialog-content">
        <label
          for="upload"
          class="uploadBtn"
          :disabled="canClick"
          v-if="isShowUpBtn"
        >
          <!-- <span size="medium" round>本地上传</span> -->
          <input
            type="file"
            :accept="accept"
            :disabled="canClick"
            id="upload"
            name="upload"
            multiple
            ref="ipt"
            @change="addFile"
          />
        </label>
        <div class="no-res-wrap" v-if="uploadingList.length === 0">
          <div class="no-res">
            <img
              src="../../assets/img/empty-upload-res.png"
              width="140"
              alt=""
            />
            <label for="upload" class="uploadBtn">
              <span size="medium" round class="temp">选择本地文件上传</span>
            </label>
          </div>
        </div>
        <div class="res-list" v-else>
          <div
            class="res-item"
            v-for="(item, index) in uploadingList"
            :key="index"
          >
            <div class="res-wrap">
              <!-- <div class="res-box"> -->
              <div class="progress-info">
                <div
                  class="progress__inner"
                  :style="{ width: item.progress }"
                ></div>
                <div class="res-info-box">
                  <div class="uploadleft">
                    <vmresico
                      size="mid"
                      :type="item.type"
                      class="res-img"
                    ></vmresico>
                    {{ item.titname }}
                  </div>
                  <span class="upload-status">{{ item.progress }}</span>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <img
                src="../../assets/img/icon_upload_cancel.png"
                alt=""
                @click="delFile(index)"
              />
              <img
                v-if="isFailed"
                src="../../assets/img/icon_reupload.png"
                alt=""
                @click="addFile"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer" v-if="uploadingList.length != 0">
        <div class="uploadBtnMore" v-if="isContinue">
          <label for="upload">
            <span size="medium" round class="temp">继续添加</span>
            <input
              style="display: none"
              type="file"
              :accept="accept"
              :disabled="canClick"
              id="upload"
              name="upload"
              multiple
              ref="ipt"
              @change="addFile"
            />
          </label>
        </div>
        <div class="in_block">
          <!-- <el-button type="primary" size="mini" round :loading="!!canClick" @click="handleSubmit" :disabled="disableding" v-prevent-re-click>{{disableding == false?'确认上传':'上传中....'}}</el-button> -->

          <el-button
            type="primary"
            size="mini"
            round
            :loading="!!canClick"
            @click="handleSubmit"
            :disabled="disableding"
            >{{ disableding == false ? "确认上传" : "上传中...." }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <close-upload
      :visible.sync="visiblestate"
      :lennum="len"
      @cancelUpload="closeUpload"
    ></close-upload>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import SparkMD5 from "spark-md5"; // 获取文件md5值插件
import UploadService from "@/utils/fileCenter/tencentCloud.upload";
import { createNamespacedHelpers } from "vuex";
import CloseUpload from "./Modal/closeUpload";
import { Container } from "element-ui";
import vmresico from "../../components/vm-resico/index";

export default {
  name: "ResUploader",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isContinue: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
      default: "audio/*,video/*,image/*,.rar,.zip,.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt",
    },
  },
  // components: { CloseUpload },
  components: {
    CloseUpload,
    vmresico,
  },
  data() {
    return {
      disableding: false,
      uploadInstance: null,
      uploadingList: [],
      canClick: false,
      isFailed: false,
      visiblestate: false,
      ZJcode: "",
      len: 0,
      moreCheck: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    isShowUpBtn() {
      if (this.isPrepare) {
        return true;
        // return this.uploadingList.length === 9; //最多上传9条
      } else {
        return this.uploadingList.length === 0;
      }
    },
  },

  watch: {
    // uploadingList: {
    //   handler(val) {
    //     console.log(val);
    //     var sum = val
    //     for (let index = 0; index < sum.length; index++) {
    //       // const element = array[index];
    //       if(sum[index].fileLength == 0){
    //          console.log("有资源为0的文件了，需要删除")
    //         this.uploadingList.splice(index, 1);
    //       }
    //     }
    //   },
    //   immediate: true,
    // },
    selectedChapterTitle: function () {
      this.formData.name = `${this.selectedChapterTitle}课时包`;
    },
  },

  created() {
    this.ZJcode = JSON.parse(sessionStorage.getItem("loginPlatformCode"));
  },
  mounted() {},
  methods: {
    getExt(value) {
      let index1 = value.lastIndexOf(".") + 1;
      var index2 = value.length;
      var type = value.substring(index1, index2);
      console.log(type);
      let extMap = [
        {
          label: "audio",
          ext: ["mp3", "ogg", "wav", "m4a", "mav", "wma"],
        },
        {
          label: "doc",
          ext: ["doc", "docx"],
        },
        {
          label: "excel",
          ext: ["xlsx", "xltx", "xls"],
        },
        {
          label: "html",
          ext: ["htm", "html", "php", "xhtml", "url"],
        },
        {
          label: "img",
          ext: ["gif", "png", "jpg", "bmp", "tiff", "image", "jpeg"],
        },
        {
          label: "video",
          ext: [
            "mp4",
            "rmvb",
            "mkv",
            "avi",
            "flv",
            "wmv",
            "mpeg",
            "m4v",
            "mpe",
            "mpg",
            "mov",
            "3gp",
          ],
        },
        {
          label: "pdf",
          ext: ["pdf"],
        },
        {
          label: "ppt",
          ext: ["ppt", "pptx"],
        },
        {
          label: "swf",
          ext: ["swf"],
        },
        {
          label: "tir",
          ext: ["tir"],
        },
        {
          label: "txt",
          ext: ["txt", "rtf"],
        },
        {
          label: "zip",
          ext: ["zip", "rar", "zip"],
        },
      ];
      let key = extMap.find((o) => {
        return o.ext.includes(type);
      });
      if (!key) {
        return "default file";
      }
      return key.label;
    },

    delFile(index) {
      this.uploadingList.splice(index, 1);
      this.canClick = false;
    },
    // 根据文件类型默认分类
    getResTypeId(type) {
      const jlo1arr2 = new Set([
        "doc",
        "docx",
        "xls",
        "xlsx",
        "pdf",
        "ppt",
        "pptx",
        "txt",
      ]);
      const jlo1arr4 = new Set([
        "img",
        "jpg",
        "bmp",
        "png",
        "gif",
        "jpeg",
        "mp3",
        "wma",
        "wav",
        "m4a",
      ]);
      const jlo1arr6 = new Set(["flv", "avi", "mp4", "wmv", "asf", "swf"]);
      if (jlo1arr2.has(type)) {
        return "jl02";
      } else if (jlo1arr4.has(type)) {
        return "jl06";
      } else if (jlo1arr6.has(type)) {
        return "jl25";
      } else {
        return "jl01";
      }
    },
    async addFile(e) {

      this.uploadInstance = new UploadService({
        appType: "khfw",
        userInfo: {
          userId: JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
          platformCode: JSON.parse(window.sessionStorage.getItem("Userlist"))
            .platformCode,
        },
      });

      // console.log(this.uploadInstance)

      const sourceFiles = this.$refs.ipt.files;
      // console.log(sourceFiles, "sourceFilessourceFiles");
      this.disableding = false;
      this.canClick = true;
      try {
        let promiseList = [];
        for (let i = 0; i < sourceFiles.length; i++) {
          let typecase = this.getExt(sourceFiles[i]["name"]);
          // console.log(sourceFiles[i], 'sourceFiles[i]["name"]');
          // var patrn = /#|%|&/g;
          // if (patrn.test(sourceFiles[i]["name"])) {
          //   console.log("正则表达式");
          //   this.$message({
          //     message: `文件${
          //       sourceFiles[i]["name"]
          //     }命名有特殊字符,无法上传,自动过滤删除`,
          //     type: "error",
          //     duration: 1000
          //   });
          //   continue;
          // }

          if (sourceFiles[i]["size"] == 0) {
            //大小为0的文件
            this.$message({
              message: `文件${sourceFiles[i]["name"]}是空文件,自动过滤删除`,
              type: "error",
              duration: 1000,
            });
            continue;
          }

          this.uploadingList.push({
            titname: sourceFiles[i]["name"],
            size: this.formatFileSize(sourceFiles[i].size),
            fileLength: sourceFiles[i].size,
            type: typecase,
            ext: typecase,
            status: 0,
            progress: "0%",
          });

          // console.log(this.uploadingList, "uploadingListpushpush");
          const len = this.uploadingList.length - 1;
          const fn = this.uploadInstance.upload(sourceFiles[i], {
            onProgress: (progress) => {
              const formatedProgress = isNaN(
                Math.round((progress.loaded / progress.total) * 100)
              )
                ? "上传失败"
                : Math.round((progress.loaded / progress.total) * 100) + "%";
              this.uploadingList[len].progress = formatedProgress;
              if (formatedProgress === "100%") {
                this.uploadingList[len].status = 1;
              }
            },
          });
          promiseList.push(fn);
        }
        // this.canClick = false;
        const resArr = await Promise.all(promiseList);
        const markIdx = this.uploadingList.length - resArr.length;
        console.log("上传组件内的数组:",resArr);
        resArr.forEach((res, index) => {
          const itemRes = res.data;
          this.uploadingList[markIdx + index].fid = itemRes.fid;
          this.uploadingList[markIdx + index].downloadUrl = itemRes.downloadUrl;
          this.uploadingList[markIdx + index].previewUrl = itemRes.previewUrl;
        });
      } catch (error) {
        this.isFailed = true;
        this.$message({
          message: "上传失败",
          type: "error",
          duration: 1000,
        });
        console.log(error);
      } finally {
        this.canClick = false;
        e.target.value = "";
      }
    },
    formatFileSize(limit) {
      limit = limit * 1;
      let size = "";
      if (limit < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B";
      } else if (limit < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        // 其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }

      let sizeStr = size + ""; // 转成字符串
      let index = sizeStr.indexOf("."); // 获取小数点处的索引
      let dou = sizeStr.substr(index + 1, 2); // 获取小数点后两位的值
      if (dou === "00") {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },
    handleSubmit() {
      this.disableding = true;
      // 多条数据传值
      console.log(this.uploadingList, "this.uploadingList");
      this.$emit("Multiple", this.uploadingList);
      if (this.uploadingList.length > 0) {
        console.log("上传时的文件列表---", this.uploadingList);

        this.$emit("submit", this.uploadingList);
      } else {
        this.$message.warning("请先上传资源");
      }
    },
    resetModal() {
      this.uploadingList = [];
      if (this.isPrepare) {
        this.$refs["form"].resetFields();
        this.$refs["form"].clearValidate();
      }
    },
    // 关闭上传弹出框样式
    handleClose(done) {
      if (this.uploadingList.length <= 0) {
        done();
      } else {
        this.len = this.uploadingList.length;
        this.visiblestate = true;
      }
    },
    //点击取消上传关闭弹框
    closeUpload() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped lang="less">
.uploadBtn {
  user-select: none;
  cursor: pointer;
  &[disabled] {
    pointer-events: none;
    cursor: not-allowed;
  }
  span {
    display: inline-block;
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 28px;
    color: #009dfd;
    border: 1px solid #009dfd;
    box-sizing: border-box;
    border-radius: 15px;
    margin: 20px;
  }
  .temp {
    display: inline-block;
    width: 170px;
    height: 30px;
    text-align: center;
    line-height: 28px;
    color: #fff;
    background-color: #009dfd;
    border: 1px solid #009dfd;
    box-sizing: border-box;
    border-radius: 15px;
    margin: 20px;
  }
  input {
    display: none;
  }
}
.label-tips {
  vertical-align: middle;
  margin-right: 3px;
  width: 13px;
  cursor: pointer;
}
.uploadBtnMore {
  display: inline-block;
  float: left;
  margin-left: 3%;
  cursor: pointer;
  width: 80px;
  height: 28px;
  font-size: 13px;
  text-align: center;
  line-height: 28px;
  color: #009dfd;
  border-radius: 15px;
  border: 1px solid #009dfd;
  span {
    cursor: pointer;
  }
}

.dialog-title {
  display: flex;
  height: 37px;
  justify-content: space-between;
  // align-items: center;
  padding-right: 30px;
  .description {
    // display: inline-block;
    // width: 100px;
    font-size: 10px;
    color: #008de3;
    line-height: 13px;
    // margin-right: 5%;
  }
  ::v-deep .popper-panel-des {
    margin-top: 6px;
    .popper-content {
      width: 340px;
      padding: 10px;
      color: #000;
      font-size: 13px;
      line-height: 18px;
      .formats {
        margin: 20px 0;
      }
    }
  }
  img {
    cursor: pointer;
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
.dialog-content {
  margin: 15px 0px;
  ::v-deep .popper-panel-tips {
    margin-top: 6px;
  }
  .infoTip {
    color: #555555;
  }
  .el-form {
    padding: 0 20px;
    .el-form-item {
      margin-bottom: 15px;
    }
  }

  .no-res-wrap {
    padding: 0 20px;
    .no-res {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 40px 0;
      border: 1px solid #ddd;
      border-radius: 6px;
    }
  }

  .res-list {
    padding: 0 20px;
    max-height: 300px;
    overflow-y: auto;
    margin-top: 20px;
    .res-item {
      display: flex;
      margin-bottom: 10px;
      &:last-of-type {
        margin-bottom: 0;
      }
      .res-wrap {
        flex: 1;
        background-color: #f9f9f9;
        .progress-info {
          position: relative;
          .progress__inner {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background-color: #e7edf2;
            transition: width 0.6s ease;
          }
          .res-info-box {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 10px;
            color: #000;
            .uploadleft {
              width: 690px;
            }
            .res-ico-mid {
              width: 26px;
              min-width: 26px;
              height: 26px;
              vertical-align: -0.55em;
            }
            .upload-status {
              width: 50px;
              text-align: center;
              font-size: 12px;
              color: #888;
            }
          }
        }
        .res-type {
          display: flex;
          align-items: center;
          padding: 10px 10px 4px;
          border-top: 1px solid #eaeaea;
          .label {
            width: 80px;
            margin-bottom: 10px;
          }
          .el-radio {
            margin-right: 20px;
            margin-bottom: 10px;
            ::v-deep .el-radio__label {
              padding-left: 6px;
            }
          }
        }
      }
      .btn-box {
        width: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 16px;
          cursor: pointer;
          &:nth-of-type(2) {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
.dialog-footer {
  padding-bottom: 20px;
  text-align: center;
  .el-button--mini,
  .el-button--mini.is-round {
    padding: 8px 25px;
  }
}

::v-deep .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-dialog {
    top: auto;
    left: auto;
    position: relative;
    transform: none;
  }
}
.in_block {
  display: inline-block;
  margin-right: 10%;
}
</style>
